// @core/api/endpoints/task/update_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskTemplateResponse,
  UpdateTemplateRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update template
 * Updates a task template. Only provided fields are updated.
 */
export async function UpdateTemplate(
  template_id: string,
  data: UpdateTemplateRequest,
  options?: RequestOptions
): Promise<TaskTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.put<TaskTemplateResponse>(requestPath, data, requestOptions);
}
